<template>
  <div style="display: inline">
    <el-button type="default" v-if="userAuth.can_audit_invoice" @click="showInvoic"
               class="d-flex-row funcbars-button"
               size="mini" style="margin-right: 10px"><i class="el-icon-plus"></i>发票号码
    </el-button>
    <!--    发票号码-->
    <adInvoicEnter :visible.sync="dialogInvoic" :order-invoic-list="orderInvoicList"
                   @afterInvoic="afterInvoic"/>
  </div>
</template>

<script>
import adInvoicEnter from "@/views/adOrder/components/adInvoicEnter";

export default {
  name: "adInvoicNumber",
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  components: {
    adInvoicEnter
  },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }

    }
  },
  data() {
    return {
      orderInvoicList: [],
      dialogInvoic: false,//添加发票号码弹窗
    }
  },
  methods: {
    // showContract() {
    //   this.$emit('showContract', this.tableData)
    // },

    showInvoic() {
      let _selectItems = this.dataList
      if (_selectItems && _selectItems.length > 0) {
        this.dialogInvoic = true//显示添加发票号码弹窗
        this.orderInvoicList = []
        let error_msg = false
        _selectItems.forEach((order) => {
          let el = order
          if (el.bool_undo) {
            error_msg = '存在已撤单订单，请去除勾选后再次申请';
            return false;
          }
          // else if (el.is_mark == 1 && el.pid != 0) {
          //   error_msg = '全案营销订单的子订单不需要录入发票号码';
          //   return false;
          // }
          this.orderInvoicList.push({
            id: order.id,
            order_no: order.order_no,
            company_name: order.company_name,
            customer_name: order.customer_name,
            sale: order.sale_name,
            payment_account: order.payment_account,
            pay_status: order.pay_status,
            invoice_status: order.invoice_status,
            payment_method: order.payment_method_alias,
            contract_no: order.contract_no,
            created_at: order.created_at,
            contract_filed: order.contract_filed,
            f_remark: order.f_remark,
            invoice_number: order.invoice_number,
          })
        })
        if (error_msg) {
          this.showToast({
            h: this,
            icon: "el-icon-error",
            text: error_msg,
            duration: 2000
          });
          this.dialogContract = false//关闭弹窗
        }
      } else {
        this.showToast({
          h: this,
          icon: "el-icon-error",
          text: "请至少勾选一单",
          duration: 2000
        });
      }
    },

    afterInvoic() {
      this.$emit('afterInvoic')

    },
  }
}
</script>

<style scoped>

</style>
